import type { CharacterTimelineData } from '../types/timeline';
import { buildStoryAxisPoints, groupStoryAxis, type StoryAxisBand, type StoryAxisPoint } from './storyAxis';

export type GlobalTimeAxisPoint = StoryAxisPoint;
export type GlobalTimeAxisBand = StoryAxisBand;

export function buildGlobalTimeAxis(data: CharacterTimelineData | null) {
  const points = buildStoryAxisPoints(data);
  return { points, chapterBands: groupStoryAxis(points, (point) => point.chapter), sceneBands: groupStoryAxis(points, (point) => point.scene) };
}
